// Static content for the Dr. Venkatsubramaniam landing page.

export const SERVICES = [
  {
    title: "Laser Stone Removal",
    desc: "Advanced laser lithotripsy for pain-free, precise kidney and ureteric stone removal.",
    icon: "Sparkles",
    span: 2,
  },
  {
    title: "Laser Prostate Surgery",
    desc: "Modern laser techniques for enlarged prostate — minimal bleeding, faster recovery.",
    icon: "Activity",
    span: 1,
  },
  {
    title: "Mini PCNL",
    desc: "Miniature Percutaneous Nephrolithotomy for complex kidney stones with tiny incisions.",
    icon: "ScanLine",
    span: 1,
  },
  {
    title: "Robotic Surgery",
    desc: "Da Vinci certified robotic procedures — precision, minimal scarring, fast recovery.",
    icon: "Bot",
    span: 2,
  },
  {
    title: "Kidney Transplantation",
    desc: "Comprehensive transplant services — donor evaluation, surgery & post-op care.",
    icon: "HeartHandshake",
    span: 1,
  },
  {
    title: "Paediatric Urology",
    desc: "Specialized treatment for urological conditions and congenital abnormalities in children.",
    icon: "Baby",
    span: 1,
  },
  {
    title: "Reconstructive Urology",
    desc: "Urethral stricture, ureteric reimplantation & pelvic reconstructive procedures.",
    icon: "Layers",
    span: 1,
  },
  {
    title: "Female Urinary Incontinence",
    desc: "Advanced treatments to restore urinary control and improve quality of life.",
    icon: "Flower2",
    span: 1,
  },
  {
    title: "Urological Cancers",
    desc: "Comprehensive cancer management — prostate, bladder, kidney & testicular cancers.",
    icon: "ShieldPlus",
    span: 2,
  },
  {
    title: "Andrology",
    desc: "Male sexual health, fertility evaluation & micro-surgical procedures.",
    icon: "Microscope",
    span: 1,
  },
  {
    title: "Benign Prostatic Hyperplasia",
    desc: "Multiple treatment options for enlarged prostate from medication to laser surgery.",
    icon: "Pill",
    span: 1,
  },
  {
    title: "Hydronephrosis & PUJ",
    desc: "Laparoscopic / robotic pyeloplasty for kidney drainage issues and PUJ obstruction.",
    icon: "Droplets",
    span: 1,
  },
];

export const REASONS = [
  "Kidney Stones",
  "Prostate Issues (BPH)",
  "Urinary Tract Infection",
  "Urological Cancer",
  "Male Fertility",
  "Kidney Transplant",
  "Robotic Surgery Consultation",
  "Other",
];

export const ABOUT_BADGES = [
  { label: "Robotic Surgery Certified", sub: "Intuitive Surgicals, USA" },
  { label: "Patient-Centered Care", sub: "100% Patient Focused" },
  { label: "Minimally Invasive Expert", sub: "Faster Recovery" },
  { label: "Three Languages", sub: "English · Tamil · Hindi" },
];

export const CREDENTIALS = [
  { title: "M.S (General Surgery)", sub: "Post Graduate in Surgery" },
  { title: "M.Ch (Urology)", sub: "Super Specialization in Urology" },
  { title: "D.Lap", sub: "Aesculap Academy, Germany" },
  { title: "Robotic Surgery", sub: "Intuitive Surgicals, USA" },
];

export const MEMBERSHIPS = [
  "Urological Society of India",
  "Association of Southern Urologists",
  "Tamilnadu and Pondicherry Association of Urologists",
  "Association of Surgeons of India",
];

export const TESTIMONIALS = [
  {
    tag: "Kidney Stone Treatment",
    quote:
      "Had severe kidney stone pain. Dr. Venkat performed laser surgery and I was discharged the next day. Excellent experience with minimal pain.",
    name: "Rajesh M.",
    location: "Triplicane, Chennai",
  },
  {
    tag: "BPH Treatment",
    quote:
      "After years of prostate problems, Dr. Venkat's minimally invasive procedure solved my issue completely. The staff was very supportive.",
    name: "Suresh K.",
    location: "T. Nagar, Chennai",
  },
  {
    tag: "Robotic Surgery",
    quote:
      "Dr. Venkat is a true expert in robotic surgery. My recovery was incredibly fast with minimal scarring. Highly recommended.",
    name: "Mohammed A.",
    location: "Royapettah, Chennai",
  },
];

export const FAQS = [
  {
    q: "What conditions does Dr. Venkatsubramaniam treat?",
    a: "Dr. Venkat treats the full spectrum of urological conditions — kidney stones, prostate enlargement (BPH), urological cancers (prostate, bladder, kidney, testicular), male infertility, urinary incontinence, paediatric urology and complex kidney transplantation.",
  },
  {
    q: "What is the advantage of robotic surgery?",
    a: "Robotic surgery offers superior precision, smaller incisions, less blood loss, minimal scarring and a significantly faster recovery — typically allowing patients to return to normal activities in days rather than weeks.",
  },
  {
    q: "How long is recovery after kidney stone laser treatment?",
    a: "Most patients are discharged within 24 hours. Routine activities resume within 2–3 days, and full recovery is usually complete within a week.",
  },
  {
    q: "Do you handle living-donor and deceased-donor kidney transplants?",
    a: "Yes. The practice offers comprehensive transplantation services — including donor evaluation, surgical procedure, immunosuppression management and long-term follow-up care.",
  },
  {
    q: "How can I book a private consultation?",
    a: "You can book directly through the consultation form on this page, call the practice line, or send a WhatsApp message. The team will confirm your appointment within a few hours.",
  },
];

export const PRACTICE = {
  name: "Dr. Venkatsubramaniam — Private Practice",
  address: "175, Big Street, Triplicane, Chennai — 600005",
  phone: "+91 98402 64444",
  phoneAlt: "+91 44 2844 2626",
  hours: "OPD · 9:00 AM — 9:00 PM   |   Emergency · 24 / 7",
  whatsapp: "917338882290",
  whatsappDisplay: "+91 73388 82290",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_urology-landing/artifacts/fhtzlv7u_Dr%20Venkat%20Logo%20%281%29.png";

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_health-portal-129/artifacts/jy8pz5v3_Venkat%20Photo.png";

export const CLINIC_IMAGE =
  "https://images.unsplash.com/photo-1593987314040-8e0ac84ae724?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjbGluaWMlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzgxNTQxMTR8MA&ixlib=rb-4.1.0&q=85";

export const ROBOTIC_IMAGE =
  "https://images.unsplash.com/photo-1766315746079-215ff5115e9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxyb2JvdGljJTIwc3VyZ2VyeSUyMG1lZGljYWx8ZW58MHx8fHwxNzc4MTU0MTE0fDA&ixlib=rb-4.1.0&q=85";
